import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        actions: {
            //получение комментариев
            getCommentsWithLogs({ rootState }, data) {
                data = {
                    entity:        data.entity        ? data.entity        : null,
                    entity_id:     data.entity_id     ? data.entity_id     : null,
                    only_comments: data.only_comments ? data.only_comments : null,
                    user_id:       data.user_id       ? data.user_id       : null 
                };
                return helpers.http.get({context: this, rootState}, '/comments_logs', {params: data});
            },

            //получение комментариев
            getComments({ rootState }, data) {
                data = {
                    order_by:   'created_at',
                    order_type: 'desc',
                    filter: [
                        ["entity",    "=", data.entity], "and",
                        ["entity_id", "=", data.entity_id]
                    ]
                };
                return helpers.http.get({context: this, rootState}, '/comments', {params: data});
            },

            //добавление комментария
            addComment({ rootState }, options) {
                return helpers.http.post({context: this, rootState}, '/comments', options.comment);
            },

            //обновление комментария
            updateComment({ rootState }, options) {
                return helpers.http.put({context: this, rootState}, '/comments', options.comment);
            },

            //удаление комментария
            deleteComment({ state, dispatch, rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/comments/' + options.comment_id);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/comments/store.js